import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("到付")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已付运费")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("包邮")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "no",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.no,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.no) = $event)),
                placeholder: "发货单号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "user_nickname",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.user_nickname,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.user_nickname) = $event)),
                placeholder: "用户匿称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "user_mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.user_mobile,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.user_mobile) = $event)),
                placeholder: "用户手机号码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "收件人姓名"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.mobile,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                placeholder: "收件人手机号码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "status",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.status) = $event)),
                placeholder: "状态"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{key: '', value: ''}, {key: '待发货', value: 'pending'}, {key: '已发货', value: 'delivered'}, {key: '已取消', value: 'cancel'}], (item) => {
                    return _createVNode(_component_el_option, {
                      label: item.key,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "no",
          title: "发货单号"
        }),
        _createVNode(_component_vxe_column, {
          field: "user_nickname",
          title: "用户匿称"
        }),
        _createVNode(_component_vxe_column, {
          field: "user_mobile",
          title: "用户手机号码"
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "收件人姓名"
        }),
        _createVNode(_component_vxe_column, {
          field: "mobile",
          title: "收件人手机号码"
        }),
        _createVNode(_component_vxe_column, {
          field: "area",
          title: "地区"
        }),
        _createVNode(_component_vxe_column, {
          field: "address_detail",
          title: "详细地址"
        }),
        _createVNode(_component_vxe_column, {
          field: "note",
          title: "备注"
        }),
        _createVNode(_component_vxe_column, {
          field: "status_display",
          title: "状态"
        }),
        _createVNode(_component_vxe_column, {
          field: "shipping_fee_type",
          title: "运费方式",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            (row.shipping_fee_type === 'freight_collect')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : (row.shipping_fee_type === 'paid')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "info",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_at",
          title: "更新时间"
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_by",
          title: "更新人"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'shipping_order_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}